import React, {useState,useEffect, useRef} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { Modal, Box, Stack,Alert,Button,Grid,Chip,
    Divider,Tooltip,TextField,Select, Autocomplete,Radio,RadioGroup,FormControlLabel,Checkbox,
    FormControl,MenuItem, InputAdornment } from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosSharpIcon,
    CheckSharp as CheckSharpIcon,
    CloudUploadOutlined as CloudUploadOutlinedIcon,
    FileDownloadOutlined as FileDownloadOutlinedIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon,
    Label
}
    from '@mui/icons-material';

import { getPropertyInfo, updateAppState } from '../../actions/appstate';
import { getData365 } from '../DailyFlash/functions';
import dataService from '../../services/data.service';
import { deepCopy, getTransformedSegments,generateTableHead, generateTable,
    safeReference, isEmptyObj,getRestrictionsArray } from "../../app/util";
import { getPricingDataFormatted } from '../DynamicTable/tilesData/pricing';
import { UPDATE_STATE } from "../../actions/types";
import { APP_CACHE } from '../../app/config';
import CustomCalendar from "../CustomCalendar";

const customInfoIcon = (
    <svg
        className='info-icon'
        xmlns="http://www.w3.org/2000/svg"
        width="13" height="13" fill="#606060"
        viewBox="0 0 256 256"
    >
        <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
    </svg>
);
const customTickIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#606060"
        viewBox="0 0 256 256"
    >
        <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"></path>
    </svg>
);
const customChipDeleteIcon = (
    <svg className="custom-chip-delete-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#606060" viewBox="0 0 256 256"><path d="M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>
)
function BulkPushModal({modalOpen,handleModalClose}) {
    // const { user, profile } = auth;
    const dispatch = useDispatch();
    const blankRestriction = { cta: false, ctd: false, close: false, min_los:null, max_los:null, };
    const {auth} = useSelector(appState => appState);
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const [compState, setcompState] = useState({ restrictionOpen: false, 
        entryFields: [], entry: {...blankRestriction}, progress:"loaded",saveReady:false,
        modified: false });
    const selectedCalendarDates = useRef([])
    const property_info = getPropertyInfo(auth.profile.property_details, app_state.property_id);
    const {market_segment_category_mapping, market_segment_category_order,market_code_ignorelist
    } = property_info.system_settings[0];
    let type = "restrictions";
    if(ui_state.active_tiles[0] === "pricing"){
        type = "pricing"
    }
    const hasExceptions = (property_info.permissions.restriction_exception === 1);
    // const [dateRange, setDateRange] = useState();
    const    dateRange = useRef({date_from:app_state.as_of_date, 
        date_until:moment(app_state.as_of_date).add(89,"days").format("YYYY-MM-DD")})
    const [dataLevel, setDataLevel] = useState("Hotel");
    const [categoryList, setCategoryList] = useState([]);
    const [dataLvlOptions, setDataLvlOptions] = useState([]);
    const [segmentOptions, setSegmentOptions] = useState([])
    const [ratePlanOptions, setRatePlanOptions] = useState([])
    const [selectedRoomClasses, setSelectedRoomClasses] = useState([])
    const [selectedRoomCodes, setSelectedRoomCodes] = useState([])
    const [selectedSegments, setSelectedSegments] = useState([])
    const [selectedRatePlans, setSelectedRatePlans] = useState([]);
    const [selectedRateType, setSelectedRateType] = useState('bar_rate');
    const [valueType, setValueType] = useState("add_currency");
    const [baseOnly, setBaseOnly] = useState(false);
    const [baseRoom, setBaseRoom] = useState({})
     const [rateValue, setRateValue] = useState("");
     const [pricingData, setPricingData] = useState([])
    const [exceptions, setExceptions] = useState([
        {display:"CTA", value:"cta", active:false, open:false, 
        exceptions:{}},
        {display:"CTD", value:"ctd", active:false,  open:false,
        exceptions:{}},
        {display:"Close", value:"close", active:false,open:false,
        exceptions:{}},
    ])
    const getCurrentData = ()=>{
        setcompState(prev => {return {...prev,  progress:"loading"} });
        const data_sources =["OSRRateRecommend"];
        const mainPromises=[];
        data_sources.forEach(src=>{
            /// call the api with custom date range

          const apiCallStarting = getData365({...app_state, date_from:dateRange.current.date_from, 
            date_until:dateRange.current.date_until,removeCompId:true, customRange:true},src);
          mainPromises.push(apiCallStarting);
        })
        
        Promise.allSettled(mainPromises).then(settled=>{
          const dataArray = settled.map((item, index) => {
              if (item.status === 'fulfilled') {
                  
                  return {...item.value, data_id:data_sources[index]};
              } else {
                  return { data: [], status: 'error', data_id: item.reason.data_id, message: item.reason.message };
              }
          });
          dataArray.forEach((res)=>{
            if(res.status === "success"){
              const finalData = { data: deepCopy(res.data) };
                finalData.data_id = res.data_id;
                finalData.ok = true;
                dataService.updateDataCache(res.data_id , { data: finalData, loaded: true, loading: false});
  
              if(res.data_id === "OSRRateRecommend"){
                // this will get the custom range data format
                
                const PricingData = getPricingDataFormatted({primary_stay_range:dateRange.current, 
                    room_settings:app_state.room_settings}, true,res.data);
                dispatch({
                    type: UPDATE_STATE, payload: { 
                        app_state: { 
                            primary_stay_range:{
                                date_from:dateRange.current.date_from,
                                date_until:dateRange.current.date_until,
                            }
                        }
                    }
                });
                console.log("historicalRange",app_state.historicalRange)
                setcompState(prev => {return {...prev, progress:"loaded"} });
                setPricingData(prev=> PricingData);
              }
            }
          });
        }).catch(err=>{
          console.log(err);
    
        })
    }
    
    useEffect(() => {
        let isSubscribed =true;
        let superTypes = {
            // "All":[],
          };
        let categoryList = [];
        let {room_settings} = app_state;
        room_settings.forEach((room, index) => {
            if (superTypes[room.room_class]) {
                superTypes[room.room_class].push(room.room_code)
            } else {
                superTypes[room.room_class] = [room.room_code]
        
            }
            if(room.is_base){
                setBaseRoom(prev=> room);
            }
            // superTypes["All"].push(room.room_code);
        });
        Object.keys(superTypes).map(type => {
            categoryList.push({ room_class: type, room_codes: superTypes[type] });
        })
        setCategoryList(prev=> categoryList);
        setDataLevel("Hotel")

        setcompState(prev=>{
            return {...prev,entry: {...blankRestriction}, restrictionOpen:false , saveReady:false, modified:false}
        })

        setPricingData(prev=> {
            return  getPricingDataFormatted({primary_stay_range:{
                date_from:moment(app_state.as_of_date).format("YYYY-MM-DD"),
                date_until:moment().add(59,"days").format("YYYY-MM-DD")
            }, room_settings:app_state.room_settings}, true)
        })
        if(modalOpen ===true){
            setExceptions(prev=>{
                return [
                    {display:"CTA", value:"cta", active:false, open:false, 
                    exceptions:{}},
                    {display:"CTD", value:"ctd", active:false,  open:false,
                    exceptions:{}},
                    {display:"Close", value:"close", active:false,open:false,
                    exceptions:{}},
                ];
            })
            const rateCodesMapping = dataService.getSeriesById("GetRateCodeMapping").data;
            if(ui_state.active_tiles[0]==='pricing'){
                getCurrentData()
            }
            let segments = getTransformedSegments(market_segment_category_mapping,
                 market_code_ignorelist);
            let codes = Object.keys(segments.map);
            let ratePlanCodes = [];
            codes.map((code) => {
                if (rateCodesMapping && rateCodesMapping["agg"][code]) {
                    ratePlanCodes = [...ratePlanCodes, ...rateCodesMapping["agg"][code]];
                }
            });
            selectedCalendarDates.current = [];
            setSelectedRoomCodes(prev=> []);
            setSelectedRoomClasses(prev=> []);
            setBaseOnly(false);
            setValueType("add_currency");
            setRateValue(null);
            setSegmentOptions(prev=>{
                return [...market_segment_category_order];
            })
            setRatePlanOptions(prev=>{
                return [...ratePlanCodes];
            })
            
        }
        if(property_info.permissions.restrictions ===1){
            const options = [{display:"Hotel", value:"Hotel"} ] /// add in the room type properly
          
            if(property_info.permissions.restriction_d.restriction_room_type === true ){
                options.push({display:"Room Type", value:"RoomType"})
            }
            if(property_info.permissions.restriction_d.restriction_rate_plan === true ){
               
                options.push({display:"Rate Plan", value:"RatePlan"})
            }
            setDataLvlOptions(prev=>{
                
                return [...options ]
            })
        }
        return () => {
            isSubscribed=false;
        }
    }, [modalOpen])
    const isValidLosValue = (value) => {
        // Convert to number if string

        
        // Check if it's a valid number
        if (isNaN(value)) {
            return false;
        }
        
        // Valid if:
        // - Value is 0 (remove restriction)
        // - Value is greater than 1 (actual restriction)
        // - Skip value of 1 since it's the default/no restriction state
        return value === 0 || value > 1;
    };
    
    const updateEntry =(key, updated_value)=>{
        const blank = {...blankRestriction, min_los:1, max_los:1};
        const oldEntry = deepCopy({ ...blank, min_los:"", max_los:"" });
    
        if(key === "cta" || key === "ctd" || key ==="close"){
            compState.entry[key] = !compState.entry[key];
        }else {
            if(key  === "open"){
                compState.restrictionOpen = !compState.restrictionOpen;
                if(compState.restrictionOpen){
                    compState.entry["cta"] =false;
                    compState.entry["ctd"] =false;
                    compState.entry["close"] =false;
                }
                
            }else if(key === "max_los" || key === "min_los"){
                updated_value = parseInt(updated_value)
                
                updated_value = (isNaN(updated_value) && updated_value!=="")  ? "":updated_value;
                compState.entry[key] = (updated_value ===1) ?  '' : updated_value
            }else {
                compState.entry[key] = updated_value;
            }
        }
        if (compState.entry.cta === true
                || compState.entry.ctd === true
                || compState.entry.close === true) {
                compState.restrictionOpen = false;
                
        }  else {
            //compState.restrictionOpen = true;
        }
        setExceptions(prev=>{
            let indexOf= 0;
            prev =  prev.map((i, index)=>{
                if(i.value === key){
                    i.active = compState.entry[key];
                   i.open = compState.entry[key];
                    indexOf = index;
                } else if( !compState.entry[key] === false){
                    i.open = false;
                }
                return i;
            });
            if(compState.entry[key] === true && indexOf !== 0){
                let temp = prev[0];
                prev[0]= prev[indexOf];
                prev[0].animate = "goUp";
                temp.animate= "goDown";
                prev[indexOf]= temp;
            }
            
            return prev;
        })
        setcompState(state => {
            // debugger
            
            let newEntry = deepCopy({ ...state.entry, ...compState.entry });
            if(newEntry.min_los === 1){
                newEntry.min_los ='';
            }
            if(newEntry.max_los === 1){
                newEntry.max_los ='';
            }

            // if (newEntry.min_los === '') {
            //     delete newEntry.min_los;
            // }
            // if (newEntry.max_los === '') {
            //     delete newEntry.max_los;
            // }
            let oldEntryStr = JSON.stringify({ ...blank, ...oldEntry });
            let newEntryStr = JSON.stringify({ ...blank, ...newEntry });

            let modified = false;
            let saveReady = false;
            Object.keys(newEntry).forEach(res=>{
                if (res === "cta" || res === "ctd" || res === "close") {
                    if (compState.entry[res] === true) {
                        modified = true;
                    }
                } else if (res === "min_los" || res === "max_los") {
                    if (isValidLosValue(newEntry[res])) {
                        modified = true;
                    }
                }
            })
            if(compState.restrictionOpen){
                modified = true;
            }

          
            console.log("modified",modified);
            return { ...state, modified, entry: { ...newEntry}, restrictionOpen:compState.restrictionOpen }
        })
        
       
    
    }
    const handleOnChangeText=(key)=>{
        return (event) => {
            let {value} = event.target;
            value = parseInt(value);
            value = (value<0) ? "":value;
            value = isNaN(value) ? "":value;
        
            const prevVal = (compState.entry[key]) ? compState.entry[key] : "";
            if(value !== prevVal || value ===""){
             
                if( value !=="" ){
                    compState.modified = true;
                }
                //else {
                //     compState.modified = false;
                // }
                if (key === 'min_los' || key === 'max_los') {
                    compState.entry[key] = value;

                }
                if(compState.entry["min_los"] === "" && compState.entry["max_los"] === ""){
                    compState.modified = false;
                }
               
                setcompState(state => {
               
                    return { ...state, ...compState }
                })
            }
        }
    }
    const handleSaveEntry = ()=>{
        const entry = {...compState.entry};
        const delta ={};
        if(compState.restrictionOpen){
            entry.open = true;
            delta.open = true;
        }
        if(compState.entry.close){
            entry.close = true;
            delta.close = true;
        }
        if(compState.entry.cta){
            entry.cta = true;
            delta.cta = true;
        }
        if(compState.entry.ctd){
            entry.ctd = true;
            delta.ctd = true;
        }

        if( compState.entry?.min_los !== 1){
            entry.min_los = compState.entry.min_los;
            delta.min_los = true;
        }
        if(compState.entry?.max_los !== 1) {
            entry.max_los = compState.entry.max_los;
            delta.max_los = true;
        }
        if(dataLevel === "Hotel"){
            const hotelLvlRestrictions =[];
           
            selectedCalendarDates.current.forEach(item=>{
                if(hasExceptions){
                    let curRest= {
                        cur:{close: false, cta:false, ctd:false},
                        delta:{...delta, exceptions:true},
                        entry:{cta:entry.cta, ctd:entry.ctd, close:entry.close, exceptions:{
                            cta:{},ctd:{},close:{}
                        }},
                        stay_date:item.date
                    }
                    console.log(curRest);
                    Object.keys(entry).forEach(i=>{
                        if(i ==="cta" || i==="ctd" || i ==="close"){
                            if(entry[i] === true){
                               let exceptionsCur=exceptions.find(ex=> ex.value === i);
                               if(!isEmptyObj(exceptionsCur.exceptions)){
                                    let  exceptionsValues ={}
                                    Object.keys(exceptionsCur.exceptions).forEach(key=>{
                                        if(exceptionsCur.exceptions[key]!==""){
                                            exceptionsValues[key]= exceptionsCur.exceptions[key];
                                            
                                        }
                                    })
                                    curRest.entry.exceptions[i]=exceptionsValues;
                               }
                            }
                        }
                    });
                    hotelLvlRestrictions.push(curRest);
                }else {
                    hotelLvlRestrictions.push({
                        cur:{close: false, cta:false, ctd:false, open:false},
                        delta:delta,
                        entry:entry,
                        stay_date:item.date
                    })
                }
                
            })
            dispatch({
                type: UPDATE_STATE, payload: { 
                    app_state: { 
                        bulkRestrictionsSave:true,
                        savedRestrictions: [...hotelLvlRestrictions] 
                        
                    }, ui_state:{
                        sendRestrictionsModalOpen:true
                    },
                }
            });
           
        }
        if(dataLevel === "RoomType"){
            const roomTypeRestrictions =[];
           
            let room_codes =[];
           
            room_codes= room_codes.concat(selectedRoomCodes);
            selectedCalendarDates.current.forEach(item=>{
                const restrictionByDate = {
                    stay_date:item.date
                };

                if(hasExceptions){
                    let curRest= {
                        cur:{close: false, cta:false, ctd:false, open:false},
                        delta:{...delta, exceptions:true},
                        entry:{cta:entry.cta, ctd:entry.ctd, close:entry.close, exceptions:{
                            cta:{},ctd:{},close:{}
                        }},
                        stay_date:item.date
                    }
                    console.log(curRest);
                    Object.keys(entry).forEach(i=>{
                        if(i ==="cta" || i==="ctd" || i ==="close"){
                            if(entry[i] === true){
                               let exceptionsCur=exceptions.find(ex=> ex.value === i);
                               if(!isEmptyObj(exceptionsCur.exceptions)){
                                    let  exceptionsValues ={}
                                    Object.keys(exceptionsCur.exceptions).forEach(key=>{
                                        if(exceptionsCur.exceptions[key]!==""){
                                            exceptionsValues[key]= exceptionsCur.exceptions[key];
                                            
                                        }
                                    })
                                    curRest.entry.exceptions[i]=exceptionsValues;
                               }
                            }
                        }
                    });
                    room_codes.forEach(code=>{
                        restrictionByDate[code]= {...curRest, room_type:code}
                    })
                }else{
                    room_codes.forEach(code=>{
                        restrictionByDate[code]= {
                            cur:{close: false, cta:false, ctd:false},
                            delta:delta,
                            entry:entry,
                            room_type:code
                        }
                    })
                }
               
                roomTypeRestrictions.push(restrictionByDate)
            })
            dispatch(updateAppState("roomTypeRestrictions", {
                app_state: { 
                    bulkRestrictionsSave:true,
                    roomTypeRestrictions: [...roomTypeRestrictions] 
                },
                ui_state:{
                    sendRestrictionsModalOpen:true
                },
            }));
        }
        handleModalClose();
    }
    const modifyCalendarDates= (calendarDates)=>{
        console.log(calendarDates.filter(i=> i.active));
        selectedCalendarDates.current = [...calendarDates.filter(i=> i.active)]
        if(selectedCalendarDates.current.length>0){
            setcompState(state => {
               
                return { ...state, saveReady:true }
            })
        }else {
            setcompState(state => {
               
                return { ...state, saveReady:false }
            })
        }
        
    }   
    const renderExceptions = ()=>{
        if(hasExceptions ){
            return (<Grid className='restriction-popup-container-2' container >
                {exceptions.map((res, exceptionIndex)=>{
                    if(!res.exceptions){
                        res.exceptions = {};
                    }
                    ['minadvance', 'maxadvance', 'minprice', 'maxprice', 'minlos','maxlos'].forEach((key)=>{
                        if(!res.exceptions[key]){
                            res.exceptions[key]="";
                        }
                    });
                    return (<Box onAnimationEnd={()=>{
                        setExceptions(prev=>{
                            prev = prev.map(i=>{
                                i.animate="";
                                return i;
                            })
                            return prev;
                        })
                    }} className={"restriction-exception-item "+res.animate }>
                    
                    <Grid container className={'restriction-exception-header ' + ( res.active  && "active ")}>
                       
                        <Grid xs={10} className="restriction-popup-title-1" >
                            {res.display} Exceptions
                        </Grid>
                        <Grid xs={2} >
                            {!res.open && <KeyboardArrowDownIcon  onClick={()=>{ 
                                if(res.active){
                                  
                                    setExceptions(prev=>{
                                       
                                        prev = prev.map((i, index)=>{
                                            if(i.value === res.value){
                                                i.open = true;
                                            }else {
                                                i.open = false;
                                            }
                                            return i;
                                        })
                                        // let temp = prev[0];
                                        // prev[0]= prev[exceptionIndex];
                                        // prev[0].animate = "goUp";
                                        // temp.animate= "goDown";
                                        // prev[exceptionIndex]= temp;
                                        return prev;
                                    });

                                }
                               
                            }} style={{float:"right", cursor:"pointer"}}/>}
                            {res.open && <KeyboardArrowUpIcon onClick={()=>{ 
                               setExceptions(prev=>{
                                prev = prev.map(i=>{
                                    if(i.value === res.value){
                                        i.open = false;
                                    } 
                                    return i;
                                })
                                return prev;
                            })
                            }} style={{float:"right", cursor:"pointer"}}/>}
                            
                        </Grid>
                        
                       
                    </Grid>
                    <Box className={"restrictions-exceptions-inputs " + (res.open && "open")}>
                        <Box className={'restriction-popup-input-container '}>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Min Advance</div>
                                    <div>
                                        <Tooltip title="Restriction will not apply if the guest books this number of days or more in Advance" sx={{ mt: 0.5 }} arrow>
                                            {customInfoIcon}
                                        </Tooltip>
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.minadvance}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
               
                                            return { ...state, ...compState }
                                        })
                                      
                                        
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.minadvance=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.minadvance;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Max Advance</div>
                                    <div>
                                        <Tooltip title="Restriction will not apply if the guest books this number of days or less in Advance." sx={{ mt: 0.5 }} arrow>
                                            {customInfoIcon}
                                        </Tooltip>
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.maxadvance}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
               
                                            return { ...state, ...compState }
                                        })
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.maxadvance=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.maxadvance;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>

                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Min Length</div>
                                    <div>
                                        <Tooltip title="Restriction will not apply if the guest stays this number or more (Nights)" sx={{ mt: 0.5 }} arrow>
                                            {customInfoIcon}
                                        </Tooltip>
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.minlos}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
               
                                            return { ...state, ...compState }
                                        })
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.minlos=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.minlos;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Max Length</div>
                                    <div>
                                        <Tooltip title="Restriction will not apply if guests stay this number or fewer (Nights)." sx={{ mt: 0.5 }} arrow>
                                            {customInfoIcon}
                                        </Tooltip>
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.maxlos}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
               
                                            return { ...state, ...compState }
                                        })
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.maxlos=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.maxlos;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>
                
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Min Price</div>
                                    <div>
                                        {/* <Tooltip title="Enter '0' to remove LOS" sx={{ mt: 0.5 }} arrow>
                                            <svg className='info-icon' xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#606060" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path></svg>
                                        </Tooltip> */}
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.minprice}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
               
                                            return { ...state, ...compState }
                                        })
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.minprice=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.minprice;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <div className='input-lebel'>Max Price</div>
                                    <div>
                                        {/* <Tooltip title="Enter '0' to remove LOS" sx={{ mt: 0.5 }} arrow>
                                            <svg className='info-icon' xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#606060" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path></svg>
                                        </Tooltip> */}
                                    </div>
                                </Box>
                
                                <TextField
                                    fullWidth
                                    className='textfield'
                                    placeholder='00'
                                    value={res.exceptions.maxprice}
                                    onChange={(e)=>{
                                        let exceptionVal = parseInt(e.target.value);
                                        if( e.target.value !=="" ){
                                            compState.modified = true;
                                        }else {
                                            exceptionVal="";
                                        }
                                        setcompState(state => {
                                            return { ...state, ...compState }
                                        })
                                        setExceptions(prev=>{
                                            prev = prev.map(i=>{
                                                if(i.value === res.value){
                                                    i.exceptions.maxprice=exceptionVal;
                                                    if(exceptionVal === ""){
                                                        delete i.exceptions.maxprice;
                                                    }
                                                }
                                                return i;
                                            })
                                            return prev;
                                        })
                                    }}
                                >
                
                                </TextField>
                            </Box>
                        </Box>
                    </Box>
                    
                    </Box>)
                })}
            </Grid>)
        }
        return (<div></div>)
    }
    let title  = "Restrictions Bulk Update";
    if(type === "pricing"){
         title  = "Pricing Bulk Update";
    }
    const handleRateTypeChange = (e)=>{
        setSelectedRateType(e.target.value);
    }
    const calculateOverrideRate = (previousRate,valueType, rateValue)=>{
        if(previousRate){
            previousRate = parseInt(previousRate);
            rateValue = parseInt(rateValue);
            if(valueType === "add_currency"){
                return previousRate+rateValue;
            }
            if(valueType === "subtract_currency"){
                return previousRate-rateValue;
            }
            if(valueType === "add_percent"){
                return previousRate+ Math.round(( rateValue/ 100) * previousRate );
            }
            if(valueType === "subtract_percent"){
                return previousRate - Math.round(( rateValue/ 100) * previousRate );
            }
        }
    }
    const handleSavePricing = ()=>{
        console.log(app_state.roomtype_pricing_overrides);
        console.log(selectedCalendarDates);
        console.log(selectedRateType);
        console.log(valueType);
        console.log(rateValue);
        console.log(pricingData);
        console.log(baseRoom)
       
            const roomTypePricing ={};
           
            let room_codes =[];
            // selectedRoomClasses.forEach(item=>{
            //     const categoryIndex = categoryList.findIndex(i => i.room_class ===item );
            //     if(categoryIndex>-1){
            //         room_codes = room_codes.concat(categoryList[categoryIndex].room_codes);
            //     }
            // });
            room_codes= room_codes.concat(selectedRoomCodes);
            if(dataLevel  === "Hotel"){
                room_codes = app_state.room_settings.map(i=> {
                    // i.code = i.room_code;
                    return i.room_code;
                });
            }
            console.log(room_codes)
          
            selectedCalendarDates.current.forEach(item=>{
                let datedata =  pricingData.find(i=> i.stay_date === item.date);
                if(item.active === true ){
                    roomTypePricing[item.date]={};
                    if(dataLevel  === "Hotel"){
                        if(selectedRateType === "bar_rate"){
                            roomTypePricing[item.date][baseRoom.room_code]= {"SellRate":rateValue};
                        }
                        if(selectedRateType=== "rate_modifier"){
                            let previousRate = (datedata[baseRoom.room_code] && datedata[baseRoom.room_code].SellRate) ? datedata[baseRoom.room_code].SellRate : 0;
                            let newRate = calculateOverrideRate(previousRate, valueType, rateValue)
                            roomTypePricing[item.date][baseRoom.room_code]= {"SellRate":newRate};
                            console.log("rate_modifier")
                        }
                        roomTypePricing[item.date][baseRoom.room_code].previous_data = {
                            RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                            SellRate:datedata[baseRoom.room_code].SellRate,
                            baseRoom:{
                                RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                                SellRate:datedata[baseRoom.room_code].SellRate,
                            }
                        }
                    }
                    room_codes.forEach(code=>{
                        if(dataLevel === "RoomType"){
                            if(selectedRateType === "bar_rate"){
                                roomTypePricing[item.date][code]= {"SellRate":rateValue};
                            }
                            else if(selectedRateType=== "rate_modifier"){
                               let previousRate = (datedata[code] && datedata[code].SellRate) ? datedata[code].SellRate : 0;
                               let newRate = calculateOverrideRate(previousRate, valueType, rateValue)
                               roomTypePricing[item.date][code]= {"SellRate":newRate};
    
                            }
                            roomTypePricing[item.date][code].previous_data = {
                                RecSellRate:datedata[code].RecSellRate,
                                SellRate:datedata[code].SellRate,
                                baseRoom:{
                                    RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                                    SellRate:datedata[baseRoom.room_code].SellRate,
                                }
                            }
                        }else if(dataLevel === "Hotel" && baseOnly === false){
                            if(selectedRateType === "bar_rate"){
                                if(baseRoom.room_code === code){
                                    roomTypePricing[item.date][code]= {"SellRate":rateValue};
                                }else {
                                    let diff = datedata[code].SellRate - datedata[baseRoom.room_code].SellRate;
                                    let newRate = parseInt(rateValue) + diff;
                                    roomTypePricing[item.date][code]= {"SellRate":newRate};
                                }
                            }
                            else if(selectedRateType=== "rate_modifier"){
                               let previousRate = (datedata[code] && datedata[code].SellRate) ? datedata[code].SellRate : 0;
                               let newRate = calculateOverrideRate(previousRate, valueType, rateValue)
                               console.log(newRate)
                               roomTypePricing[item.date][code]= {"SellRate":newRate};
    
                            }
                            roomTypePricing[item.date][code].previous_data = {
                                RecSellRate:datedata[code].RecSellRate,
                                SellRate:datedata[code].SellRate,
                                baseRoom:{
                                    RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                                    SellRate:datedata[baseRoom.room_code].SellRate,
                                }
                            }
                        }
                        
                        
                    })
                }
               
            })
            console.log("roomTypePricing end", roomTypePricing);
            dispatch({
                type: UPDATE_STATE, payload: { 
                    app_state: { 
                        roomtype_pricing_overrides:{...roomTypePricing},
                        bulkPricingSave:true,
                    }
                }
            });
        handleModalClose();
        APP_CACHE.pricingRateModalOpen =true;
        dispatch({
            type: UPDATE_STATE, payload: { ui_state: { pricingRateModalOpen: true } }
        });
        // setTimeout(()=>{
           
           
        // },100)
       
    }
    let restrictionsSection = (<Box component="section" className="restrictions-section"  sx={{ p: 2 }}>
    <div className="section-title">Select Restrictions</div>
    <Grid className='restriction-popup-container-1' container >



    <Box className='restriction-popup-switch-container'>
        <Box
            className={compState.restrictionOpen === true ? 'restriction-popup-switch open active' : 'restriction-popup-switch open'}
            onClick={()=>{updateEntry('open')}}
        >
            {compState.restrictionOpen ===true ? customTickIcon : ''}
            <div>Open</div>
        </Box>

        <Box
            className={compState.entry.cta ? 'restriction-popup-switch cta active' : 'restriction-popup-switch cta'}
            onClick={()=>{updateEntry('cta')}}
        >
            {compState.entry.cta ? customTickIcon : ''}
            <div>CTA</div>
        </Box>

        <Box
            className={compState.entry.ctd ? 'restriction-popup-switch ctd active' : 'restriction-popup-switch ctd'}
            onClick={()=>{updateEntry('ctd')}}
        >
            {compState.entry.ctd ? customTickIcon : ''}
            <div>CTD</div>
        </Box>

        <Box
            className={compState.entry.close ? 'restriction-popup-switch close active' : 'restriction-popup-switch close'}
            onClick={()=>{updateEntry('close')}}
        >
            {compState.entry.close ? customTickIcon : ''}
            <div>Close</div>
        </Box>
    </Box>

    {!hasExceptions && (<Box className='restriction-popup-input-container' mt={0.5}>
    <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <div className='input-lebel'>Min LOS</div>
                <div>
                    <Tooltip title="Enter '0' to remove LOS" sx={{ mt: 0.5 }} arrow>
                        {customInfoIcon}
                    </Tooltip>
                </div>
            </Box>

            <TextField
                fullWidth
                className='textfield colord2'
                //placeholder='00'
                value={compState.entry.min_los}
                onBlur={(e)=>{updateEntry('min_los', e.target.value)}}
                onChange={handleOnChangeText('min_los')}
            >

            </TextField>
        </Box>
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <div className='input-lebel'>Max LOS</div>
                <div>
                    <Tooltip title="Enter '0' to remove LOS" sx={{ mt: 0.5 }} arrow>
                        {customInfoIcon}
                    </Tooltip>
                </div>
            </Box>

            <TextField
                fullWidth
                className='textfield colord1'
                //placeholder='00'
                value={compState.entry.max_los}
                onBlur={(e)=>{updateEntry('max_los', e.target.value)}}
                onChange={handleOnChangeText('max_los')}
            >

            </TextField>
        </Box>
        

    </Box>)}
</Grid>

    <Box className="restrictions-exceptions-box">{renderExceptions()}</Box>
    </Box>)
    
    let pricingSection =(<Box component="section" className="pricing-section" >
    <div className="section-title">Select type</div>
    <Grid className='restriction-popup-container-1' container >
         <Grid item xs={12} className='bulk-rp-form-box'>
         <RadioGroup
            className='bulk-rp-form-ele'
            row
            aria-labelledby="controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={selectedRateType}
            onChange={handleRateTypeChange}
        >
            <FormControlLabel className='bulk-rp-form-radio' value="bar_rate" control={<Radio />} label="BAR Rate" />
            <FormControlLabel className='bulk-rp-form-radio' value="rate_modifier" control={<Radio />} label="Rate Modifier" />
        </RadioGroup>
        </Grid>
        
        <Grid item xs={12} className='bulk-rp-form-box'>
            
            <FormControl className='bulk-rp-form-ele' fullWidth>
                {/* {selectedRateType=== "rate_modifier" && (<Select 
                    className='bulk-rp-form-ele'
                    id="value-type"
                    value={valueType}
                    onChange={(e)=>{
                        setValueType(e.target.value);
                    }}>
                    <MenuItem value={"add_currency"}>{"+"+ui_state.currency_symbol}</MenuItem>
                    <MenuItem value={"subtract_currency"}>{"-"+ui_state.currency_symbol}</MenuItem>
                    <MenuItem value={"add_percent"}>{"+%"}</MenuItem>
                    <MenuItem value={"subtract_percent"}>{"-%"}</MenuItem>
                </Select>)} */}
                <label className="input-label">Value</label>
                <TextField className='prefix-ele' size="small" id="value-input"  value={rateValue} variant="outlined" 
                    InputProps={{
                        startAdornment: <InputAdornment position="start">

                            {selectedRateType=== "rate_modifier" && (<Select 
                                className='prefix-ele-select'
                                id="value-type"
                                value={valueType}
                                onChange={(e)=>{
                                    setValueType(e.target.value);
                                }}>
                                <MenuItem value={"add_currency"}>{"+"+ui_state.currency_symbol}</MenuItem>
                                <MenuItem value={"subtract_currency"}>{"-"+ui_state.currency_symbol}</MenuItem>
                                <MenuItem value={"add_percent"}>{"+%"}</MenuItem>
                                <MenuItem value={"subtract_percent"}>{"-%"}</MenuItem>
                            </Select>)}

                            {selectedRateType === "bar_rate" && (<span>{ui_state.currency_symbol }</span>)}

                        </InputAdornment>,
                    }}
                    onChange={(e)=>{                
                        let value = isNaN(parseInt(e.target.value)) ? "" : parseInt(e.target.value);
                        console.log(value);
                        setRateValue(value);
                        if(value !== ""){
                            setcompState(prev=>{
                                return {...prev, modified:true}
                            })
                        }else {
                            setcompState(prev=>{
                                return {...prev, modified:false}
                            })
                        }
                    
                    }} 
                />
            </FormControl>   
        </Grid>
        
        <Grid item xs={12}>
            <Divider sx={{mb:2}}/>
            <div className="section-title">Rooms</div>
        </Grid>
        <Grid item xs={12}>
            <FormControl className='bulk-rp-form-box'>
            <label>Select Data Level</label>
            <Select
            className='bulk-rp-form-ele'
            labelId=""
            id="data-level-select"
            label=""
            value={dataLevel}
            onChange={(e)=>{
                let val = e.target.value;
                console.log(val);
                setDataLevel(e.target.value);
                if(e.target.value === "Hotel"){
                    setcompState(prev=>{
                        return {...prev}
                    })
                }else {
                    let saveReady = false;
                    if(e.target.value === "RoomType" &&
                    ( selectedRoomClasses.length>0 || selectedRoomCodes.length>0)
                    ){
                        saveReady = true;
                    }
                    setcompState(prev=>{
                        return {...prev}
                    })
                }
            
            }}
                >
                <MenuItem value={"Hotel"}>Hotel</MenuItem>
                <MenuItem value={"RoomType"}>Room Type</MenuItem>
        </Select>
        </FormControl>
        <br/>
        {(dataLevel === "RoomType")  && (<>     
            <FormControl className='bulk-rp-form-box'>
            <label>Room Class</label>
            <Autocomplete
                className='bulk-rp-form-ele'
                size="small"
                multiple
                options={categoryList.map(i=> i.room_class)}
                freeSolo
                value={selectedRoomClasses}
                onChange={(e, newVal) => {
                    if(newVal.length>0 && selectedCalendarDates.current.length>0){
                        setcompState(prev=>{
                            return {...prev, saveReady:true}
                        })
                    }else {
                        setcompState(prev=>{
                            return {...prev, saveReady:false}
                        })
                    }
                    setSelectedRoomClasses(prev=> newVal);
                    let selectedRoomCodes=[];
                    app_state.room_settings.forEach(room => {
                        if(newVal.indexOf(room.room_class)>-1){
                            selectedRoomCodes.push(room.room_code);
                        }
                    });
                    setSelectedRoomCodes(prev=> selectedRoomCodes);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            key={"id-" + index}
                            size="small"
                            variant="filled"
                            // color="primary"
                            label={option}
                            {...getTagProps({ index })}
                            deleteIcon={customChipDeleteIcon}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        className="textfield"
                        {...params}
                        size="small"
                        variant="outlined"
                        label=""
                        placeholder="Type room class and press enter"
                    />
                )}
            />
            </FormControl>
            <br/>
            <FormControl className='bulk-rp-form-box'>
            <label>Room Code</label>
            <Autocomplete
                className='bulk-rp-form-ele'
                size="small"
                multiple
                options={app_state.room_settings.map(i=> i.room_code)}
                freeSolo
                value={selectedRoomCodes}
                onChange={(e, newVal) => {
                    if(newVal.length>0 && selectedCalendarDates.current.length>0){
                        setcompState(prev=>{
                            return {...prev, saveReady:true}
                        })
                    }else {
                        setcompState(prev=>{
                            return {...prev, saveReady:false}
                        })
                    }
                    setSelectedRoomCodes(prev=> newVal);
                    let selectedRoomClasses=[];
                    app_state.room_settings.forEach(room => {
                        if(newVal.indexOf(room.room_code)>-1
                        && selectedRoomClasses.indexOf(room.room_class) <0){
                            selectedRoomClasses.push(room.room_class);
                        }
                    });
                    setSelectedRoomClasses(prev=> selectedRoomClasses);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            key={"id-" + index}
                            size="small"
                            variant="filled"
                            // color="primary"
                            label={option}
                            {...getTagProps({ index })}
                            deleteIcon={customChipDeleteIcon}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        className="textfield"
                        {...params}
                        size="small"
                        variant="outlined"
                        label=""
                        placeholder="Type room code and press enter"
                    />
                )}
            />
            </FormControl> </>)}
        {(dataLevel === "Hotel") && (<>
            <FormControl className='bulk-rp-form-box'>
                <label>Base Room</label>
                <TextField className='bulk-rp-form-ele' size='small' value={baseRoom.room_code}/>
            </FormControl>
            <br/>
            <Box className='bulk-rp-form-ele'>
            <FormControlLabel className='bulk-rp-form-radio' control={<Checkbox  checked={baseOnly}  onChange={(e)=>{
                setBaseOnly(e.target.checked);
            }} />} label="Update Base Only" />
            </Box>
        </>)}
        </Grid>

    </Grid>
    </Box>);
    const changeDateRange = (range)=>{
        dateRange.current = range;
        getCurrentData();
    }

    return (<>
        <Modal
            className="popup-modal-wrap"
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-bulk-restrictions"
            aria-describedby="modal-bulk-restrictions"
        >
            <Box className='popup-modal modal-bulk-restrictions'>
          
            <>
                <Box className='modal-titlebar-res-review-update'>
                    <Grid container spacing={0} className='modal restrictions-update'>
                        <Grid item xs={7}>
                            <item>{title}</item>
                        </Grid>
                        <Grid className='right-cta' xs={4} item alignItems="end">

                            <Button sx={{
                                minWidth: 'auto', position: 'absolute', top: -12, right: -12, width: '24px', height: '24px', p: '7px',
                                borderRadius: '50%', borderWidth: '1px', borderStyle: 'solid',
                                borderColor: '#ccc', boxShadow: '0 0 4px #000', background: '#000', color: '#FFF', fontSize: '10px',
                                '&:hover': { backgroundColor: '#000' }
                            }} onClick={handleModalClose}>
                                <CloseSharpIcon fontSize='small' />
                            </Button>

                        </Grid>
                    </Grid>

                </Box>

                <Box sx={{ height: '100%' }}  className="bulk-popup-body">
                    <Grid container className="bulk-columns-cover">
                        <Grid item style={{width: "320px"}} className='date-range-picker-box'>
                            <div className="section-title">Select dates Range</div>
                            <CustomCalendar asOfDate={app_state.as_of_date}
                                changeDateRange={changeDateRange}
                                currentCalendarDates={selectedCalendarDates.current}
                                modifyCalendarDates={modifyCalendarDates} />
                        </Grid>
                        <Divider orientation="vertical" flexItem>
                        </Divider>
                        <Grid item xs>
                            {(type === "restrictions") && restrictionsSection}
                            {(type === "pricing") && pricingSection}
                        </Grid>
                        {(type === 'restrictions') && (<><Divider orientation="vertical" flexItem>
                        </Divider>
                        <Grid item xs>
                            <Box component="section"  className='inventory-section'>
                                <div className="section-title" >Inventory</div>
                                
                                    <FormControl className='bulk-rp-form-box'>
                                        <label>Data Level</label>
                                        <Select
                                        className='bulk-rp-form-ele'
                                        labelId=""
                                        id="data-level-select"
                                        label=""
                                        value={dataLevel}
                                        onChange={(e)=>{
                                            setDataLevel(e.target.value);
                                            console.log(e.target.value);
                                            if(e.target.value === "Hotel"){
                                                setcompState(prev=>{
                                                    return {...prev}
                                                })
                                            }else {
                                                let saveReady = false;
                                                if(e.target.value === "RoomType" &&
                                                ( selectedRoomClasses.length>0 || selectedRoomCodes.length>0)
                                                ){
                                                    saveReady = true;
                                                }
                                                setcompState(prev=>{
                                                    return {...prev}
                                                })
                                            }
                                        
                                        }}
                                            >
                                    {dataLvlOptions.map(item=> (<MenuItem value={item.value}>{item.value }</MenuItem>))}
                                    </Select>
                                    </FormControl>

                                    {(dataLevel === "RatePlan")  && (<>
                                    
                                    <FormControl className='bulk-rp-form-box'>
                                    <label>Segments</label>
                                    <Autocomplete
                                        className='bulk-rp-form-ele'
                                        size="small"
                                        multiple
                                        options={segmentOptions}
                                        freeSolo
                                        value={selectedSegments}
                                        onChange={(e, newVal) => {
                                            if(newVal.length>0 && selectedCalendarDates.current.length>0){
                                                setcompState(prev=>{
                                                    return {...prev, saveReady:true}
                                                })
                                            }else {
                                                setcompState(prev=>{
                                                    return {...prev, saveReady:false}
                                                })
                                            }
                                            setSelectedSegments(prev=> newVal);
                                        }}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    key={"id-" + index}
                                                    size="small"
                                                    variant="filled"
                                                    // color="primary"
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                //deleteIcon={<CustomChipDeleteIcon />}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                className="textfield"
                                                {...params}
                                                size="small"
                                                variant="outlined"
                                                label=""
                                                placeholder="Type room class and press enter"
                                            />
                                        )}
                                    />
                                    </FormControl>
                                    
                                    <FormControl className='bulk-rp-form-box'>
                                    <label>Rate Plan</label>
                                    <Autocomplete
                                        className='bulk-rp-form-ele'
                                        size="small"
                                        multiple
                                        options={ratePlanOptions}
                                        freeSolo
                                        value={selectedRatePlans}
                                        onChange={(e, newVal) => {
                                            if(newVal.length>0 && selectedCalendarDates.current.length>0){
                                                setcompState(prev=>{
                                                    return {...prev, saveReady:true}
                                                })
                                            }else {
                                                setcompState(prev=>{
                                                    return {...prev, saveReady:false}
                                                })
                                            }
                                            setSelectedRatePlans(prev=> newVal);
                                        }}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    key={"id-" + index}
                                                    size="small"
                                                    variant="filled"
                                                    // color="primary"
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                //deleteIcon={<CustomChipDeleteIcon />}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                className="textfield"
                                                {...params}
                                                size="small"
                                                variant="outlined"
                                                label=""
                                                placeholder="Type room code and press enter"
                                            />
                                        )}
                                    />
                                    </FormControl>
                                </>)}

                                    {(dataLevel === "RoomType" || dataLevel === "RatePlan")  && (<>
                                    
                                        <FormControl className='bulk-rp-form-box'>
                                        <label>Room Class</label>
                                        <Autocomplete
                                            className='bulk-rp-form-ele'
                                            size="small"
                                            multiple
                                            options={categoryList.map(i=> i.room_class)}
                                            freeSolo
                                            value={selectedRoomClasses}
                                            onChange={(e, newVal) => {
                                                if(newVal.length>0 && selectedCalendarDates.current.length>0){
                                                    setcompState(prev=>{
                                                        return {...prev, saveReady:true}
                                                    })
                                                }else {
                                                    setcompState(prev=>{
                                                        return {...prev, saveReady:false}
                                                    })
                                                }
                                                setSelectedRoomClasses(prev=> newVal);
                                                let selectedRoomCodes=[];
                                                app_state.room_settings.forEach(room => {
                                                    if(newVal.indexOf(room.room_class)>-1){
                                                        selectedRoomCodes.push(room.room_code);
                                                    }
                                                });
                                                setSelectedRoomCodes(prev=> selectedRoomCodes);
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={"id-" + index}
                                                        size="small"
                                                        variant="filled"
                                                        // color="primary"
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        deleteIcon={customChipDeleteIcon }
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    className="textfield"
                                                    {...params}
                                                    size="small"
                                                    variant="outlined"
                                                    label=""
                                                    placeholder="Type room class and press enter"
                                                />
                                            )}
                                        />

                                        </FormControl>
                                        
                                        <FormControl className='bulk-rp-form-box'>
                                        <label>Room Code</label>
                                        <Autocomplete
                                            className='bulk-rp-form-ele'
                                            size="small"
                                            multiple
                                            options={app_state.room_settings.map(i=> i.room_code)}
                                            freeSolo
                                            value={selectedRoomCodes}
                                            onChange={(e, newVal) => {
                                                if(newVal.length>0 && selectedCalendarDates.current.length>0){
                                                    setcompState(prev=>{
                                                        return {...prev, saveReady:true}
                                                    })
                                                }else {
                                                    setcompState(prev=>{
                                                        return {...prev, saveReady:false}
                                                    })
                                                }
                                                setSelectedRoomCodes(prev=> newVal);
                                                let selectedRoomClasses=[];
                                                app_state.room_settings.forEach(room => {
                                                    if(newVal.indexOf(room.room_code)>-1
                                                    && selectedRoomClasses.indexOf(room.room_class) <0){
                                                        selectedRoomClasses.push(room.room_class);
                                                    }
                                                });
                                                setSelectedRoomClasses(prev=> selectedRoomClasses);
                                            }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={"id-" + index}
                                                        size="small"
                                                        variant="filled"
                                                        // color="primary"
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        deleteIcon={customChipDeleteIcon}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    className="textfield"
                                                    {...params}
                                                    size="small"
                                                    variant="outlined"
                                                    label=""
                                                    placeholder="Type room code and press enter"
                                                />
                                            )}
                                        />
                                        </FormControl>
                                    </>)}

                            </Box>
                        </Grid></>)}
                    </Grid>
                    <Box className="bulk-popup-footer">
                        <div className="info-text">
                            To select multiple options, simply hold down the Shift key and click on the Week, Days, or Week Number.
                        </div>
                        {(type === "restrictions") && <>
                            <Button
                                disabled={(!compState.modified && !compState.saveReady) }

                                className={(compState.modified || compState.saveReady ) ? "navigate-cancel-button btn-active" : "navigate-cancel-button"}

                                variant="outlined"
                                size="small"
                                sx={{ minWidth: "auto" }}
                                onClick={() => {  
                                    handleModalClose();
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                disabled={!compState.modified || !compState.saveReady || compState.progress ==="loading" }
                                className={(compState.modified && compState.saveReady && compState.progress ==="loaded") ? "navigate-save-button btn-active" : "navigate-save-button"}
                                variant="outlined"
                                size="small"
                                sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
                                onClick={()=>{
                                    handleSaveEntry()
                                }}
                            >
                                Update
                            </Button>
                        </>}
                        {(type === "pricing") && <>
                            <Button
                                className="navigate-cancel-button btn-active"
                                variant="outlined"
                                size="small"
                                sx={{ minWidth: "auto" }}
                                onClick={() => {  
                                    handleModalClose();
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                disabled={!compState.modified || !compState.saveReady}
                                className={(compState.modified && compState.saveReady) ? "navigate-save-button btn-active" : "navigate-save-button"}
                                variant="outlined"
                                size="small"
                                sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
                                onClick={()=>{
                                    handleSavePricing()
                                }}
                            >
                                Update
                            </Button>
                        </>}

                        
                    </Box>
                    {compState.pushError && (<Stack sx={{ width: '100%', paddingLeft: "16px", paddingRight: "16px",marginBottom:"10px" }} spacing={2}>
                        <Alert severity="warning" sx={{ color: "#333333", background: "rgba(224, 49, 49, 0.10)", pt: "0px", pb: "0px", border: "1px solid #E03131" }}>
                            Something Went Wrong, Please Try Again</Alert>
                    </Stack>)}
                </Box>
                </>



            </Box>
        </Modal>
    </>);
}

export default BulkPushModal
